import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { redirectLandingPage } from '@app/core/helpers/utils';

@Component({
  selector: 'app-join-session',
  templateUrl: './join-session.component.html',
  styleUrls: ['./join-session.component.scss'],
})
export class JoinSessionComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<JoinSessionComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: { isGuest: boolean }) {

  }

  isGuest = false;
  closeDialog(data?: any) {
    this.dialogRef.close(data);
  }

  ngOnInit(): void {
    this.isGuest = this.data.isGuest;
  }

  joinSession() {
    this.closeDialog(true);
  }


  close() {
    if (this.isGuest) {
      redirectLandingPage();
      this.closeDialog();
    }
    else {
      this.closeDialog();
    }
  }

}